import createEntityDuck from '../../util/genericEntityDuck';

const namespace = 'settings';
const storeKey = 'organizationUsers';

const duck = createEntityDuck(namespace, storeKey, 'userId', namespace);

export { duck as default, storeKey };
export const { creators, reducer, types, selectors, initialState } = duck;
